export const CALENDARFEED_GET_URLS = 'CALENDARFEED_GET_URLS';
export const CALENDARFEED_GET_URLS_OK = 'CALENDARFEED_GET_URLS_OK';
export const CALENDARFEED_GET_URLS_FAIL = 'CALENDARFEED_GET_URLS_FAIL';

export const CALENDARFEED_GENERATE_URLS = 'CALENDARFEED_GENERATE_URLS';
export const CALENDARFEED_GENERATE_URLS_OK = 'CALENDARFEED_GENERATE_URLS_OK';
export const CALENDARFEED_GENERATE_URLS_FAIL = 'CALENDARFEED_GENERATE_URLS_FAIL';
